
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faQuestionCircle as farQuestionCircle,
    } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';

    export default {
        name: 'WhatIsThis',

        components: {
            FontAwesomeIcon,
        },

        props: {
            title: {
                type: String,
                default: '',
            },

            primaryText: {
                type: String,
                default: '',
            },

            secondaryText: {
                type: String,
                default: '',
            },

            placement: {
                type: String,
                default: 'topleft',
            },

            hideLabel: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isActive: true,
                icons: {
                    farQuestionCircle,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'what-is-this',
                    this.getActiveClass,
                ];
            },

            getActiveClass() {
                return this.isActive ? 'what-is-this--active' : '';
            },

            popoverConfig() {
                return {
                    html: true,
                    customClass: 'what-is-this-popover',
                    title: this.title,
                    placement: this.placement,
                    content: () => {
                        let output = this.primaryText;
                        if (this.secondaryText) {
                            output += '<div class="text-secondary">\n' +
                                `${this.secondaryText}\n` +
                                '</div>';
                        }
                        return output;
                    },
                };
            },
        },

        methods: {
            show() {
                this.isActive = true;
            },

            hide() {
                this.isActive = true;
            },

            handleClick() {
                return false;
            },
        },
    };
